<template>
  <app-data-editor
    :id="id"
    title="Редактирование Склада"
    resource="warehouses"
    :elements="elements"
    add-message="Склад добавлен"
    edit-message="Склад изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              width: 8,
              required: true,
              rules: [
                (v) => !!v || "Наименование обязательно к заполнению",
                (v) =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
          {
            title: "Группажный склад",
            name: "groupedWarehouse",
            control: {
              type: "bool-switch",
              width: 2,
            },
          },
          {
            title: "Наш склад",
            name: "ourWarehouse",
            control: {
              type: "bool-switch",
              width: 2,
              disabled: true,
              tooltip: "Изменение доступно через Настройки/Склад по умолчанию",
            },
          },
        ],
        [
          {
            title: "Страна",
            name: "country",
            control: {
              type: "reference",
              resource: "countries",
              component: "Country",
              required: true,
              rules: [(v) => !!v || ""],
            },
          },
          {
            title: "Адрес",
            name: "address",
            control: {
              type: "reference",
              component: "Address",
              resource: "addresses",
              required: true,
              rules: [(v) => !!v || ""],
              parentFilter: "countryId",
              parentField: "country",
              withoutParentLock: true,
            },
          },
        ],
        [
          {
            title: "Телефон",
            name: "phone",
            control: {
              type: "phone",
              required: true,
              rules: [(v) => !!v || "Телефон обязателен к заполнению"],
            },
            default: "",
          },
          {
            title: "Email",
            name: "email",
            control: {
              type: "email",
              required: true,
              rules: [
                (v) => !!v || "Email обязателен к заполнению",
                (v) => {
                  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  return pattern.test(v) || "Invalid e-mail.";
                },
              ],
            },
            default: "",
          },
        ],
        [
          {
            title: "Расписание",
            name: "timetable",
            control: {
              type: "text",
              required: true,
              rules: [(v) => !!v || "Расписание обязательно к заполнению"],
            },
            default: "",
          },
          {
            title: "Источник",
            name: "source",
            control: {
              type: "text",
              required: true,
              rules: [(v) => !!v || "Источник обязателен к заполнению"],
            },
            default: "",
          },
          {
            title: "Специализация",
            name: "specialization",
            control: {
              type: "text",
            },
            default: "",
          },
        ],
        [
          {
            title: "Контактные лица",
            name: "contactPersons",
            getDataPath: "Contacts",
            saveDataPath: "Contacts",
            control: {
              type: "reference-list",
              resource: "contact-persons",
              searchPlaceholder: "Контактное лицо",
              component: "ContactPerson",
              columns: [
                { title: "Имя", name: "name" },
                { title: "Фамилия", name: "surname" },
                {
                  title: "Телефон",
                  name: "phones",
                  valueFn(item) {
                    return Array.isArray(item.phones)
                      ? item.phones.length > 1
                        ? item.phones.join(", ")
                        : item.phones.join()
                      : item.phones;
                  },
                },
                {
                  title: "Email",
                  name: "emails",
                  valueFn(item) {
                    return Array.isArray(item.emails)
                      ? item.emails.length > 1
                        ? item.emails.join(", ")
                        : item.emails.join()
                      : item.emails;
                  },
                },
                { title: "Роль", name: "role", data: "role.title" },
              ],
              dataTest: "contactPerson",
            },
            default: [],
          },
        ],
      ],
    };
  },
};
</script>
